import { useEffect } from 'react';

export function useBeforeNavigateAway(show: boolean) {
  useEffect(() => {
    if (!show) return;

    const handleBeforeUnload = (event: any) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [show]);
}